import { StatementAccountTypeCategory, StatementTypeCategory } from '@/utils'
import passwordGuidelineImageUrl from '../../assets/statements-password-guidelines.png'

interface TabSwitcherProps {
  tabs: string[]
  activeTab: string | null
  onTabChange: (tab: string) => void
  selectedCategory?: string
}

const TabSwitcher = ({
  tabs,
  activeTab,
  onTabChange,
  selectedCategory,
}: TabSwitcherProps) => {
  let filteredTabs: string[] = tabs
  if (selectedCategory === StatementTypeCategory.UT) {
    filteredTabs = tabs.filter(
      (tab) =>
        tab === StatementAccountTypeCategory.STATEMENT ||
        tab === StatementAccountTypeCategory.PASSWORD_GUIDELINE
    )
  } else if (selectedCategory === StatementTypeCategory.PRS) {
    filteredTabs = tabs.filter(
      (tab) =>
        tab === StatementAccountTypeCategory.STATEMENT ||
        tab === StatementAccountTypeCategory.ACCOUNT
    )
  }
  return (
    <div className='flex flex-wrap gap-2 sm:gap-6 justify-start mt-6 w-full'>
      {filteredTabs.map((tab) =>
        tab === StatementAccountTypeCategory.PASSWORD_GUIDELINE ? (
          <a
            key={tab}
            href={passwordGuidelineImageUrl}
            target='_blank'
            rel='noopener noreferrer'
            className={`px-[5%] py-2 cursor-pointer text-pi-principal-blue font-normal text-base`}
          >
            {StatementAccountTypeCategory.PASSWORD_GUIDELINE}
          </a>
        ) : (
          <button
            key={tab}
            onClick={() => onTabChange(tab)}
            className={`px-[5%] py-2 rounded-full cursor-pointer ${
              activeTab === tab
                ? 'bg-pi-sky-blue-1 text-pi-principal-blue border-pi-principal-blue'
                : 'bg-[#fff] text-black'
            }`}
          >
            {tab}
          </button>
        )
      )}
    </div>
  )
}

export default TabSwitcher
